import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98ecc25a")

_pushScopeId("data-v-98ecc25a")
const _hoisted_1 = { class: "actions" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "Histórico", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-alt" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "Transferência", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, "Entrada", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-minus" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, "Saída", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ODialog = _resolveComponent("ODialog")

  return (_openBlock(), _createBlock(_component_ODialog, {
    visible: _ctx.visibleComputed,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.visibleComputed = $event)),
    modal: true,
    "show-header": false,
    "dismissable-mask": "",
    "content-style": "padding: 0",
    breakpoints: { '640px': '90vw' },
    style: { width: '512px' },
    "data-test": "inventorySummaryDialog"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "history",
          "data-test": "history",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleHistory && _ctx.handleHistory(...args)))
        }, [
          _hoisted_2,
          _hoisted_3
        ]),
        _createVNode("div", {
          class: "transfer",
          "data-test": "transfer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleTransfer && _ctx.handleTransfer(...args)))
        }, [
          _hoisted_4,
          _hoisted_5
        ]),
        _createVNode("div", {
          class: "in",
          "data-test": "in",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleIn && _ctx.handleIn(...args)))
        }, [
          _hoisted_6,
          _hoisted_7
        ]),
        _createVNode("div", {
          class: "out",
          "data-test": "out",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleOut && _ctx.handleOut(...args)))
        }, [
          _hoisted_8,
          _hoisted_9
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
})